import { render, staticRenderFns } from "./TabsC.vue?vue&type=template&id=22d6e2a3&scoped=true&lang=pug&"
import script from "./TabsC.vue?vue&type=script&lang=js&"
export * from "./TabsC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d6e2a3",
  null
  
)

export default component.exports